/**
 * Whether this build is a customized (white-label) app rather than the generic KigaRoo/Clubity app.
 * True when the runtime config either restricts login to a single `organization` or scopes it to a
 * `federationIds` list (the native parent-app clients are configured via federationIds, not a single
 * organization). Read as a function so it evaluates after main.ts has merged the dynamic config.
 */
export function getIsCustomizedApp(): boolean {
    return !!window.kgrDynamicConfig.organization || !!window.kgrDynamicConfig.federationIds?.length;
}
